import {WEB_DEVICE} from '../constants/StepConstants';

export const isNumber = (value: string | number): boolean => ((value != null) && !isNaN(Number(value.toString())));

export const isWebDevice = device =>
    device.toLowerCase() === WEB_DEVICE.toLowerCase();